import { Box, Grid2 as Grid, Typography } from '@mui/material';
import PerformanceCard from './PerformanceCard';
import PerformanceCardSkeleton from './PerformanceCardSkeleton';
import { useTranslation } from 'react-i18next';

export default function PerformanceGrid({ performanceData, isLoading }) {
  const { t } = useTranslation(['description']);

  if (isLoading) {
    return (
      <Grid container spacing={2} size={12} columns={10}>
        {Array.from({ length: performanceData.length || 5 }).map((_, index) => (
          <Grid key={index} size={{ xs: 10, lg: 2 }}>
            <PerformanceCardSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={{ xs: 12 }}>
        <Typography variant="h6" component="h2">
          {t('description:payments.dashboard.performance_metrics')}
        </Typography>
      </Grid>

      <Grid
        size={{ xs: 12, lg: 'auto' }}
        sx={{ display: { xs: 'block', lg: 'none' }, width: '100%' }}
      >
        <Box
          sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 2,
            pb: 1,
            '&::-webkit-scrollbar': {
              height: '0px',
            },
          }}
        >
          {performanceData.map((performance, index) => (
            <Box
              key={index}
              sx={{
                flexShrink: 0,
                width: '80%',
              }}
            >
              <PerformanceCard
                avatar={performance.avatar}
                title={performance.title}
                icon={performance.icon}
                value={performance.value}
                valueMuted={performance.valueMuted}
                footerTitle={performance.footerTitle}
                footerDescription={performance.footerDescription}
                helperText={performance.helperText}
              />
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid
        container
        size={12}
        columns={10}
        sx={{ display: { xs: 'none', lg: 'flex' } }}
      >
        {performanceData.map((performance, index) => (
          <Grid key={index} size={{ lg: 2 }}>
            <PerformanceCard
              avatar={performance.avatar}
              title={performance.title}
              icon={performance.icon}
              value={performance.value}
              valueMuted={performance.valueMuted}
              footerTitle={performance.footerTitle}
              footerDescription={performance.footerDescription}
              helperText={performance.helperText}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
